import { render, staticRenderFns } from "./GoodsCombinationStatus.vue?vue&type=template&id=f32e6d46&scoped=true&"
import script from "./GoodsCombinationStatus.vue?vue&type=script&lang=js&"
export * from "./GoodsCombinationStatus.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCombinationStatus.vue?vue&type=style&index=0&id=f32e6d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32e6d46",
  null
  
)

export default component.exports